export const feedbacks = [
  {
    text: "Абсолютно все понравилось. Лучший ментор, даже не почувствовала, что занимаемся удаленно потому что всегда была колоссальная поддержка. Полина - профессионал своего дела. Она отлично обьясняет, аналогии из жизни приводит так, что человеку без технического бэкграунда становится понятно.",
    author: "Golovach Lena"
  },
  {
    text: "Абсолютно все понравилось. Лучший ментор, даже не почувствовала, что занимаемся удаленно потому что всегда была колоссальная поддержка. Полина - профессионал своего дела. Она отлично обьясняет, аналогии из жизни приводит так, что человеку без технического бэкграунда становится понятно.",
    author: "Yasha Lava"
  },
  {
    text: "Абсолютно все понравилось. Лучший ментор, даже не почувствовала, что занимаемся удаленно потому что всегда была колоссальная поддержка. Полина - профессионал своего дела. Она отлично обьясняет, аналогии из жизни приводит так, что человеку без технического бэкграунда становится понятно.",
    author: "Vasya"
  },
  {
    text: "Абсолютно все понравилось. Лучший ментор, даже не почувствовала, что занимаемся удаленно потому что всегда была колоссальная поддержка. Полина - профессионал своего дела. Она отлично обьясняет, аналогии из жизни приводит так, что человеку без технического бэкграунда становится понятно.",
    author: "Lisa Lisa"
  },
  {
    text: "Абсолютно все понравилось. Лучший ментор, даже не почувствовала, что занимаемся удаленно потому что всегда была колоссальная поддержка. Полина - профессионал своего дела. Она отлично обьясняет, аналогии из жизни приводит так, что человеку без технического бэкграунда становится понятно.",
    author: "Andrey Putin"
  }
]